import { useMemo, useCallback } from "react";
import { useIntl } from "react-intl";
import { getPersonStatusLabel } from "../utils/personProposalOrigin";
export var useNaturalPersonTable = function (onRowClick) {
    var intl = useIntl();
    var formatMessage = intl.formatMessage;
    var handleNameClick = useCallback(function (item) {
        onRowClick(item);
    }, [onRowClick]);
    var columns = useMemo(function () { return [
        {
            name: formatMessage({
                id: "ui-br-agency.natural-person.table.columns.lastName",
            }),
            key: "lastName",
            clickable: true,
            onClick: handleNameClick,
        },
        {
            name: formatMessage({
                id: "ui-br-agency.natural-person.table.columns.firstName",
            }),
            key: "firstName",
            clickable: true,
            onClick: handleNameClick,
        },
        {
            name: formatMessage({
                id: "ui-br-agency.natural-person.table.columns.birthDate",
            }),
            key: "birthDate",
            cellRenderer: function (item) { var _a; return (_a = item === null || item === void 0 ? void 0 : item.birthDate) !== null && _a !== void 0 ? _a : ""; },
        },
        {
            name: formatMessage({
                id: "ui-br-agency.natural-person.table.columns.deathDate",
            }),
            key: "deathDate",
            cellRenderer: function (item) { var _a; return (_a = item === null || item === void 0 ? void 0 : item.deathDate) !== null && _a !== void 0 ? _a : ""; },
        },
        {
            name: formatMessage({
                id: "ui-br-agency.natural-person.table.columns.biographicalNote",
            }),
            key: "biographicalNote",
            cellRenderer: function (item) {
                var _a;
                var note = (_a = item === null || item === void 0 ? void 0 : item.biographicalNote) !== null && _a !== void 0 ? _a : "";
                return note.length > 80 ? note.substring(0, 80) + "..." : note;
            },
        },
        {
            name: formatMessage({
                id: "ui-br-agency.natural-person.table.columns.status",
            }),
            key: "status",
            // A proposal names its origin (DB-899), other statuses stay as they are.
            cellRenderer: function (item) { return getPersonStatusLabel(intl, item); },
        },
    ]; }, [formatMessage, intl, handleNameClick]);
    return {
        columns: columns,
    };
};
